import { ModalProps } from 'antd/lib/modal';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectBaseline } from 'api/project';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Modal } from 'components/atoms/modal';
import { BaselineForm } from './form';

interface Props extends ModalProps {
  baselines: ProjectBaseline[];
  onSubmit: (formValues) => void;
  isSubmitting: boolean;
}

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Footer = ({
  isSubmitting,
  onSubmit,
  onCancel,
}: Pick<Props, 'onSubmit' | 'isSubmitting' | 'onCancel'>) => {
  return (
    <ButtonGroup>
      <Button type="link" onClick={onCancel}>
        <FormattedMessage id="cancel" />
      </Button>
      <Button loading={isSubmitting} type="primary" onClick={onSubmit}>
        <FormattedMessage id="save" />
      </Button>
    </ButtonGroup>
  );
};

export const BaselineAddModal = ({
  baselines,
  onSubmit,
  isSubmitting,
  ...rest
}: Props) => {
  const [form] = Form.useForm();

  const onAdd = useCallback(async () => {
    const formValues = await form.validateFields();

    onSubmit(formValues);
  }, [form, onSubmit]);

  return (
    <Modal
      {...rest}
      zIndex={1051}
      centered
      visible
      footer={
        <Footer
          isSubmitting={isSubmitting}
          onSubmit={onAdd}
          onCancel={rest.onCancel}
        />
      }
      title={<FormattedMessage id="baseline.new" />}
      okText={<FormattedMessage id="create" />}
      onOk={onAdd}
    >
      <BaselineForm form={form} baselines={baselines} />
    </Modal>
  );
};
